import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-10" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex align-items-center mb-2" }
const _hoisted_10 = {
  href: "javasript:;",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_11 = {
  key: 0,
  href: "javascript:;"
}
const _hoisted_12 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_13 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_14 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_15 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_16 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_19 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_20 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_21 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_22 = { class: "d-flex flex-wrap" }
const _hoisted_23 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_26 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  All USID Balance", -1)
const _hoisted_28 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_31 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_32 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_33 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_36 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  EC Wallet", -1)
const _hoisted_38 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_41 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  MG Pay", -1)
const _hoisted_43 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, null, -1)
const _hoisted_46 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Travel GC", -1)
const _hoisted_48 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_51 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Product GC", -1)
const _hoisted_53 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_56 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Sponsor ID", -1)
const _hoisted_58 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_61 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Upline ID", -1)
const _hoisted_63 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_66 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Position", -1)
const _hoisted_68 = {
  key: 3,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_69 = { class: "d-flex align-items-center" }
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_71 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Date Of Registration", -1)
const _hoisted_73 = {
  key: 4,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_76 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "   * PCP Enrollment", -1)
const _hoisted_78 = {
  key: 5,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_79 = { class: "d-flex align-items-center" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_81 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Total Purchased PCP Product", -1)
const _hoisted_83 = {
  key: 6,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_84 = { class: "d-flex align-items-center" }
const _hoisted_85 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_86 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Target Milestone", -1)
const _hoisted_88 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("div", null, [
          _createVNode(_component_el_skeleton, {
            rows: 2,
            animated: ""
          })
        ], 512), [
          [_vShow, _ctx.loadingBalance]
        ]),
        _withDirectives(_createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: _ctx.user.avatar,
              alt: "image"
            }, null, 8, ["src"]),
            (_ctx.showRankImage)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.rankPrimeImage,
                  class: "",
                  height: "50",
                  width: "50",
                  style: _ctx.rankPrimeImageStyle
                }, null, 12, ["src"]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, !_ctx.loadingBalance]
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("a", _hoisted_10, _toDisplayString(_ctx.user.fname) + " " + _toDisplayString(_ctx.user.lname), 1),
                (!_ctx.isBiboPremium)
                  ? (_openBlock(), _createBlock("a", _hoisted_11, [
                      _createVNode("span", _hoisted_12, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Verified.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("a", _hoisted_14, [
                  _createVNode("span", _hoisted_15, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.user.usid), 1)
                ]),
                _createVNode("a", _hoisted_16, [
                  _createVNode("span", _hoisted_17, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Map/Marker1.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.user.address), 1)
                ]),
                _createVNode("a", _hoisted_18, [
                  _createVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Mail-at.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.user.email), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _withDirectives(_createVNode("div", null, [
                _createVNode(_component_el_skeleton, {
                  rows: 2,
                  animated: ""
                })
              ], 512), [
                [_vShow, _ctx.loadingBalance]
              ]),
              _withDirectives(_createVNode("div", _hoisted_22, [
                _withDirectives(_createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.overAllAvailableBalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_27
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.balance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _createVNode("div", _hoisted_32, "  " + _toDisplayString(_ctx.user.usid) + " Balance", 1)
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.ewalletbalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_37
                ], 512), [
                  [_vShow, !_ctx.loadingBalance  && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode("div", _hoisted_41, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.matchinpaybalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_42
                ], 512), [
                  [_vShow, !_ctx.loadingBalance  && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp' && _ctx.ccode === 0]
                ]),
                _withDirectives(_createVNode("div", _hoisted_43, [
                  _createVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode("div", _hoisted_46, _toDisplayString(_ctx.accountdetailsdata.travelgc), 1)
                  ]),
                  _hoisted_47
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_48, [
                  _createVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode("div", _hoisted_51, _toDisplayString(_ctx.accountdetailsdata.productgc), 1)
                  ]),
                  _hoisted_52
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_53, [
                      _createVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createVNode("div", _hoisted_56, _toDisplayString(_ctx.pcpdetails.spid), 1)
                      ]),
                      _hoisted_57
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createBlock("div", _hoisted_58, [
                      _createVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createVNode("div", _hoisted_61, _toDisplayString(_ctx.pcpdetails.upid), 1)
                      ]),
                      _hoisted_62
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createBlock("div", _hoisted_63, [
                      _createVNode("div", _hoisted_64, [
                        _hoisted_65,
                        _createVNode("div", _hoisted_66, _toDisplayString(_ctx.pcpdetails.upref == 'L' ? 'Left' : (_ctx.pcpdetails.upref == 'R' ? 'Right' : '')), 1)
                      ]),
                      _hoisted_67
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_68, [
                      _createVNode("div", _hoisted_69, [
                        _hoisted_70,
                        _createVNode("div", _hoisted_71, _toDisplayString(_ctx.formatDateMonthDayYear(_ctx.pcpdetails.regDate)), 1)
                      ]),
                      _hoisted_72
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_73, [
                      _createVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createVNode("div", _hoisted_76, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcpEnrollmentFee).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                      ]),
                      _hoisted_77
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_78, [
                      _createVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createVNode("div", _hoisted_81, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcp_product_total).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                      ]),
                      _hoisted_82
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_83, [
                      _createVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _createVNode("div", _hoisted_86, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.nextMilestone).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                      ]),
                      _hoisted_87
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !_ctx.loadingBalance]
              ]),
              (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                ? (_openBlock(), _createBlock("p", _hoisted_88, "* PCP Enrollment includes " + _toDisplayString(_ctx.pcpdetails.pcpEnrollmentInclusions), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}